import React from 'react'
import {Typography} from '@mui/material'

function CommonMapFunction(props) {

  const {data} = props
  return (
    <div>{data?.map((item, index)=>{
      return <div key={index} className='mb20'>
      <Typography variant="head5" className='fw500'> {item?.title}</Typography>
      <Typography variant="body2" className='fw400'>{item.content} </Typography>
      </div>
    })}</div>
  )
}

export default CommonMapFunction